// extracted by mini-css-extract-plugin
module.exports = {"modal_block":"CancelProposalModal_modal_block__2N1gx","footer":"CancelProposalModal_footer__3DV9b"};